// extracted by mini-css-extract-plugin
export default {"knowledgeTag":"KnowledgeTag__knowledgeTag___MdHDo"};